import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
export default (function (theme) {
  return {
    root: {
      outline: 'none',
      '&$alignLabelTop': {
        '& [class*="InputWrapper"]': {
          alignItems: 'initial',
          '& [class*="Label__root"]': {
            marginTop: 12,
            alignItems: 'initial'
          }
        }
      }
    },
    alignLabelTop: {},
    rangeWrapper: {
      marginTop: -10,
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'flex-start',
      '& > *': {
        marginRight: 16,
        '&:last-child': {
          marginRight: 0
        }
      },
      '&$verticalFieldsMode': {
        display: 'initial'
      }
    },
    verticalFieldsMode: {},
    divider: {
      height: 56,
      alignItems: 'center',
      display: 'flex'
    },
    dividerText: _objectSpread({}, theme.typography.body),
    isFullWidth: {
      '& $rangeWrapper': {
        width: '100%'
      }
    }
  };
});